import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import swal from "sweetalert";
import LogoutFunction from "../services/LogoutFunction";

export const deleteLessonsApi = createAsyncThunk(
  "lessons/delete",
  async (lessonId) => {
    const tokenData = await JSON.parse(localStorage.getItem("userData")).token;

    const request = await fetch(
      `${process.env.REACT_APP_VERSEL_API}/api/users/lessons/deleteLessonById/${lessonId}`,
      {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${tokenData}`,
        },
      }
    )
      .then((response) => response.json())
      .then((result) => {
        console.log(result);
        return result;
      })
      .catch((error) => {
        
        return error;
      });
    return request;
  }
);

function formatError(errorResponse) {
  swal("Oops", `${errorResponse}`, "error");
}

const deleteLessonsSlicer = createSlice({
  name: "deletelessons",
  initialState: {
    loading: false,
    lessons: null,
    error: null,
  },
  extraReducers: (builder) => {
    builder.addCase(deleteLessonsApi.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(deleteLessonsApi.fulfilled, (state, action) => {
      state.loading = false;
      if (action.payload.message === "Lesson Deleted successfully") {
        state.lessons = action.payload;
      }  else {
        state.error = action.payload.message;
      }
    });
    builder.addCase(deleteLessonsApi.rejected, (state, action) => {
      state.loading = false;

      state.error = action.payload.message;
    });
  },
});

export default deleteLessonsSlicer.reducer;
